export default __webpack_public_path__ + "static/4. Streamlined Centre Operations Management 2-069e27eb7a3989795ed45bdcf291ae78.png";